import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'

const FormWrapper = ({ title, lg = "8", children }) => {
  return (
    <div className="acc-form">
      <div className="card">
        <div className="card-head">
          <h4><FormattedMessage id={title} /></h4>
        </div>
        <div className="card-body">
          <Row>
            <Col lg={lg}>
              {children}
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}

export default FormWrapper